import axios from "axios";
import { header } from "./header";

export const getStateList = async () => {    
    try{
      const response = await axios.get(`${process.env.REACT_APP_OTHER_GENERIC_SERVICE}/api/OtherGenericService/GetStateList?CountryCode=${localStorage.getItem("CountryCode")}`,{headers:header()});
      return response;
    }catch(error){
      return error.response
    }
  }

  export const getCountryList = async () => {    
    try{
      const response = await axios.get(`${process.env.REACT_APP_OTHER_GENERIC_SERVICE}/api/OtherGenericService/GetCountryList?CountryCode=${localStorage.getItem("CountryCode")}`,{headers:header()});
      return response;
    }catch(error){
      return error.response
    }
  }

   export const getCountryListforUAE = async (obj) => {    
    try{
      const response = await axios.get(`${process.env.REACT_APP_OTHER_GENERIC_SERVICE}/api/OtherGenericService/GetCountryList?CountryCode=${obj.Code}`,{headers:header()});
      return response;
    }catch(error){
      return error.response
    }
  }
  export const EnScoreSignUp = async (obj) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_PRODUCTION_AUTHORITY}api/OrgApi/EnScoreSignUp?OrgCode=${obj.OrgCode}`,{headers:header()});
      return response;
    } catch (error) {
      return error.response
    }
  }
export const getScreenMenuList = async() => {
    try{
     const response = await axios.get(`${process.env.REACT_APP_PRODUCTION_AUTHORITY}api/UserAPI/GetScreenList?OrgCode=${localStorage.getItem("OrgCode")}`,{headers:header()});            
      return response;      
    }catch (error){
      return error
    }
  }
export const GetScreenListByUser = async(obj) => {
    try{
     const response = await axios.get(`${process.env.REACT_APP_PRODUCTION_AUTHORITY}api/UserAPI/GetScreenListByUserId?UserName=${obj.UserName}&OrgCode=${obj.OrgCode}&UserType=${localStorage.getItem("UserType")==="None"?"":localStorage.getItem("UserType")}`,{headers:header()});            
      return response;      
    }catch (error){
      return error
    }
  }
  export const getmodulemanagement = async(name) => {
    try{
     const response = await axios.get(`${process.env.REACT_APP_OTHER_GENERIC_SERVICE}/api/OtherGenericService/GetModuleFlagForOrg?Orgcode=${localStorage.getItem("OrgCode")}&ModuleName=${name}`,{headers:header()});            
      return response;      
    }catch (error){
      return error
    }
  }
    export const getorgcustomerinfo = async(name) => {
    try{
     const response = await axios.get(`${process.env.REACT_APP_OTHER_GENERIC_SERVICE}/api/OtherGenericService/GetSupportDetails`,{headers:header()});            
      return response;      
    }catch (error){
      return error
    }
  }
     export const curancyList = async() => {
    try{
     const response = await axios.get(`${process.env.REACT_APP_OTHER_GENERIC_SERVICE}/api/OtherGenericService/CurrencyData`,{headers:header()});            
      return response;      
    }catch (error){
      return error
    }
  }

  //for UAE partymaster
     export const getCountryListforUAEParty = async (obj) => {    
    try{
      const response = await axios.get(`${process.env.REACT_APP_OTHER_GENERIC_SERVICE}/api/OtherGenericService/GetRegionType?RegionType=${obj.Code}`,{headers:header()});
      return response;
    }catch(error){
      return error.response
    }
  }


  

  // for listany Config
  export const saveConfigaration = async (obj) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_REDIRECT_LISTINGSERVICE_APP}/api/domain/create`, obj,{ headers: {
    "Content-Type": "application/json"
  }});
      return response;
    }
    catch (error) {
      return error.response
    }
  }

    // for listany Templates Config
  export const saveCloneTemplate = async (obj) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_SALE_BASE_URL}/api/ExternalChannel/CloneTemplatesForOrg`,obj,{ headers: {
    "Content-Type": "application/json"
  }});
      return response;
    }
    catch (error) {
      return error.response
    }
  }

  export const invoiceData = async (orgCode) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_OTHER_GENERIC_SERVICE}/api/SaleInvoiceCustomization/GetSaleInvoiceSetting?orgCode=${orgCode}`, { headers: header() });
    return response;
  } catch (error) {
    return error.response
  }
}